import BunkeyAPI from '../api/BunkeyAPI'
import {
  ASSET_FAVORITES_GET_DATA,
  ASSET_FAVORITES_GET_DATA_SUCCESS,
  ASSET_FAVORITES_GET_DATA_FAILURE,
  ASSET_FAVORITES_ACTIVEVIEW,
  ASSET_FAVORITES_EDIT,
  ASSET_FAVORITES_EDIT_SUCCESS,
  ASSET_FAVORITES_EDIT_FAILURE,
  ASSET_FAVORITES_SET_SELECT,
  ASSET_FAVORITES_UNSET_SELECT,
  ASSET_FAVORITES_DELETE,
  ASSET_FAVORITES_DELETE_SUCCESS,
  ASSET_FAVORITES_DELETE_FAILURE,
  ASSET_FAVORITES_EDIT_SELECT,
  ASSET_FAVORITES_EDIT_UNSET_SELECT,
  ASSET_FAVORITES_EXPAND_SELECT,
  ASSET_FAVORITES_EXPAND_UNSET_SELECT,
  ASSET_FAVORITES_SHARE_SELECT,
  ASSET_FAVORITES_SHARE_UNSET_SELECT,
  ASSET_FAVORITES_ADD,
  ASSET_FAVORITES_ADD_SUCCESS,
  ASSET_FAVORITES_ADD_FAILURE,
  ASSET_FAVORITES_REMOVE,
  ASSET_FAVORITES_REMOVE_SUCCESS,
  ASSET_FAVORITES_REMOVE_FAILURE,
  ASSET_FAVORITES_MOVE,
  ASSET_FAVORITES_MOVE_SUCCESS,
  ASSET_FAVORITES_MOVE_FAILURE,
  ASSET_FAVORITES_CHECK_SELECT,
  ASSET_FAVORITES_UNCHECK_SELECT,
  MULTIPLE_FAVORITES_OPTIONS_ACTIVATE,
  MULTIPLE_FAVORITES_OPTIONS_DEACTIVATE,
  MULTIPLE_FAVORITES_OPTIONS_DONE,
  ASSETS_FAVORITES_MULTI_DELETE,
  ASSETS_FAVORITES_MULTI_DELETE_SUCCESS,
  ASSETS_FAVORITES_MULTI_DELETE_FAILURE,
  ASSETS_FAVORITES_MULTI_MOVE,
  ASSETS_FAVORITES_MULTI_MOVE_SUCCESS,
  ASSETS_FAVORITES_MULTI_MOVE_FAILURE,
  ASSET_FAVORITES_MULTI_ADD,
  ASSET_FAVORITES_MULTI_ADD_SUCCESS,
  ASSET_FAVORITES_MULTI_ADD_FAILURE,
  ASSET_FAVORITES_MULTI_REMOVE,
  ASSET_FAVORITES_MULTI_REMOVE_SUCCESS,
  ASSET_FAVORITES_MULTI_REMOVE_FAILURE,
} from '../constants/assets-favorites-types'
import { sendNotification, permissionsDefault, validateImageSpecialExtensions } from '../utils';
import store from '../store'

export const getFavorites = (workclient, folderselect, page = 1, isFetching = true, data = []) => {
  const user = store.getState().authUser.user
  return dispatch => {
    dispatch({
      type: ASSET_FAVORITES_GET_DATA,
      payload: {
        isFetching,
        data,
      }
    })

    BunkeyAPI({
      url: `/users/me/clients/${workclient}/favorites`,
      method: 'GET',
    }).then(resp => {
      dispatch({
        type: ASSET_FAVORITES_GET_DATA_SUCCESS,
        payload: {
          user,
          folderselect,
          page,
          workspace: resp.data._id,
          headers: resp.headers,
          data: resp.data.children
            .map(r => {
              return {
                _id: r._id,
                type: validateImageSpecialExtensions(r.originalURL) ? 'document' : r.type,
                name: r.name,
                lowQualityURL: r.lowQualityURL,
                mediaQualityURL: r.mediaQualityURL,
                originalURL: r.originalURL,
                metadata: r.metadata,
                parents: r.parents,
                createdAt: r.createdAt,
                group: r.group,
                tagProtocol: r.tagProtocol,
                objectGroups: r.objectGroup,
                user: r.user && r.username ? { id: r.user, name: r.username } : { id: '', name: '' },
                matrix: permissionsDefault().map(def => {
                  const exists = r.group.find(r => r.permissions.find(item => item.action === def.action && item.enabled === true))
                  return {
                    action: def.action,
                    enabled: exists ? true : false
                  }
                }),
                uuid: r.uuid,
                fileSizeFormat: r.fileSizeFormat,
                documentPages: r.documentPages

              }
            })
        }
      })
    }).catch(err => {
      dispatch({
        type: ASSET_FAVORITES_GET_DATA_FAILURE,
        payload: err
      })
    })
  }
}

export const setFavoritesActiveView = view => {
  return dispatch => {
    dispatch({
      type: ASSET_FAVORITES_ACTIVEVIEW,
      payload: {
        activeView: view
      }
    })
  }
}

export const setSelectFavoriteAsset = (item, indice, from, verticalCount, horizontalCount) => {
  return dispatch => {
    dispatch({
      type: ASSET_FAVORITES_SET_SELECT,
      payload: {
        data: item,
        indice,
        from,
        verticalCount,
        horizontalCount
      }
    })
  }
}

export const setEditFavoritesAsset = (workclient, asset) => {
  return dispatch => {
    dispatch({ type: ASSET_FAVORITES_EDIT })
    BunkeyAPI({
      url: `/clients/${workclient}/objects/${asset._id}`,
      method: 'PUT',
      data: {
        _id: asset._id,
        name: asset.name,
        metadata: {
          descriptiveTags: asset.metadata.descriptiveTags,
          createdDate: asset.metadata.createDate,
          dueDate: asset.metadata.dueDate
        }
      }
    }).then(resp => {
      dispatch({
        type: ASSET_FAVORITES_EDIT_SUCCESS,
        payload: {
          data: asset,
          headers: resp.headers
        }
      })
    }).catch(err => {
      dispatch({
        type: ASSET_FAVORITES_EDIT_FAILURE,
        payload: err
      })
    })
  }
}
export const unsetSelectFavoriteAsset = () => {
  return dispatch => {
    dispatch({ type: ASSET_FAVORITES_UNSET_SELECT })
  }
}

export const setSelectEditFavoritesAsset = (asset, editAssetTab) => {
  return dispatch => {
    dispatch({
      type: ASSET_FAVORITES_EDIT_SELECT,
      payload: {
        data: asset,
        editAssetTab
      }
    })
  }
}

export const unsetSelectEditFavoritesAsset = () => {
  return dispatch => {
    dispatch({
      type: ASSET_FAVORITES_EDIT_UNSET_SELECT
    })
  }
}

export const deleteFavoritesAsset = (workclient, id, intl, multiple) => {
  return dispatch => {
    dispatch({ type: ASSET_FAVORITES_DELETE })
    BunkeyAPI({
      url: `/clients/${workclient}/objects/${id}`,
      method: 'DELETE',
    }).then(resp => {
      dispatch({
        type: ASSET_FAVORITES_DELETE_SUCCESS,
        payload: {
          workclient,
          id
        }
      })
      // if (multiple) {
      sendNotification('success', intl, intl.formatMessage({ id: 'asset_has_been_deleted' }))
      // }
    }).catch(err => {
      dispatch({
        type: ASSET_FAVORITES_DELETE_FAILURE,
        payload: {
          workclient,
          id,
          error: err
        }
      })
      // if (multiple) {
      sendNotification('error', intl, intl.formatMessage({ id: 'error_deleting_asset' }))
      // }
    })
  }
}

export const setSelectExpandFavoritesAsset = (asset) => {
  return dispatch => {
    dispatch({
      type: ASSET_FAVORITES_EXPAND_SELECT,
      payload: {
        data: asset,
      }
    })
  }
}

export const unsetSelectExpandFavoritesAsset = () => {
  return dispatch => {
    dispatch({
      type: ASSET_FAVORITES_EXPAND_UNSET_SELECT
    })
  }
}

export const setSelectShareFavoritesAsset = (asset) => {
  return dispatch => {
    dispatch({
      type: ASSET_FAVORITES_SHARE_SELECT,
      payload: {
        data: asset,
      }
    })
  }
}

export const unsetSelectShareFavoritesAsset = () => {
  return dispatch => {
    dispatch({
      type: ASSET_FAVORITES_SHARE_UNSET_SELECT
    })
  }
}

export const addFavoriteAsset = (workClient, home, asset) => {
  return dispatch => {
    dispatch({ type: ASSET_FAVORITES_ADD })
    BunkeyAPI({
      url: `users/me/clients/${workClient}/favorites/${home}`,
      method: 'POST',
      data:
      {
        object: asset._id
      }
    }).then(resp => {
      dispatch({
        type: ASSET_FAVORITES_ADD_SUCCESS,
        payload: {
          data: asset
        }
      })
    }).catch(err => {
      dispatch({
        type: ASSET_FAVORITES_ADD_FAILURE,
        payload: {
          error: err
        }
      })
    })
  }
}

export const removeFavoriteAsset = (workClient, home, asset) => {
  return dispatch => {
    dispatch({ type: ASSET_FAVORITES_REMOVE })
    BunkeyAPI({
      url: `users/me/clients/${workClient}/favorites/${home}`,
      method: 'DELETE',
      data:
      {
        target: asset._id
      }
    }).then(resp => {
      dispatch({
        type: ASSET_FAVORITES_REMOVE_SUCCESS,
        payload: {
          data: asset
        }
      })
    }).catch(err => {
      dispatch({
        type: ASSET_FAVORITES_REMOVE_FAILURE,
        payload: {
          error: err
        }
      })
    })
  }
}

export const moveFavoritesAsset = (workclient, asset, folder, intl, multiple) => {
  return dispatch => {
    dispatch({ type: ASSET_FAVORITES_MOVE })
    BunkeyAPI({
      url: `/clients/${workclient}/objects/${asset._id}`,
      method: 'PUT',
      data: {
        action: 'move',
        folder: folder
      }
    }).then(resp => {
      dispatch({
        type: ASSET_FAVORITES_MOVE_SUCCESS,
        payload: {
          data: asset,
          headers: resp.headers
        }
      })
      // if (multiple) {
      sendNotification('success', intl, intl.formatMessage({ id: 'asset_has_been_moved' }))
      // }
    }).catch(err => {
      dispatch({
        type: ASSET_FAVORITES_MOVE_FAILURE,
        payload: err
      })
      sendNotification('error', intl, `${intl.formatMessage({ id: 'the_asset' })} ${asset.name} ${intl.formatMessage({ id: 'could_not_move' })}`)
    })
  }
}

export const setCheckFavoritesAsset = (asset) => {
  return dispatch => {
    dispatch({
      type: ASSET_FAVORITES_CHECK_SELECT,
      payload: asset
    })
  }
}
export const unsetCheckFavoritesAsset = (asset) => {
  return dispatch => {
    dispatch({
      type: ASSET_FAVORITES_UNCHECK_SELECT,
      payload: asset
    })
  }
}

export const activateFavoritesOptions = () => {
  return dispatch => {
    dispatch({
      type: MULTIPLE_FAVORITES_OPTIONS_ACTIVATE
    })
  }
}

export const deactivateFavoritesOptions = () => {
  return dispatch => {
    dispatch({
      type: MULTIPLE_FAVORITES_OPTIONS_DEACTIVATE
    })
  }
}

export const isDoneMultipeFavoritesOptions = () => {
  return dispatch => {
    dispatch({
      type: MULTIPLE_FAVORITES_OPTIONS_DONE
    })
  }
}
export const multiDeleteFavoritesAsset = (workclient, intl, items) => {
  return (dispatch) => {
    dispatch({ type: ASSETS_FAVORITES_MULTI_DELETE })
    BunkeyAPI({
      url: `/clients/${workclient}/objects-deletemany`,
      method: 'PUT',
      data: {
        data: items
      }
    })
      .then((resp) => {
        dispatch({
          type: ASSETS_FAVORITES_MULTI_DELETE_SUCCESS,
          payload: {
            workclient,
            ids: items,
          },
        })
        sendNotification(
          'success',
          intl,
          intl.formatMessage({ id: "assets_has_been_deleted" })
        )
      })
      .catch((err) => {
        dispatch({
          type: ASSETS_FAVORITES_MULTI_DELETE_FAILURE,
          payload: {
            workclient,
            ids: items,
            error: err,
          },
        })
        sendNotification(
          'error',
          intl,
          `${intl.formatMessage({ id: 'assets_has_not_been_deleted' })}`
        )
      })
  }
}
export const moveMultiselectFavoritesAsset = (workclient, ids, folder, intl) => {
  return dispatch => {
    dispatch({ type: ASSETS_FAVORITES_MULTI_MOVE })
    BunkeyAPI({
      url: `/clients/${workclient}/objects-movemany/${folder}`,
      method: 'PUT',
      data: {
        data: ids
      }
    }).then(resp => {
      dispatch({
        type: ASSETS_FAVORITES_MULTI_MOVE_SUCCESS,
        payload: {
          ids: ids,
          headers: resp.headers
        }
      })
      // if (multiple) {
      sendNotification('success', intl, intl.formatMessage({ id: 'assets_have_been_moved' }))
      // }
    }).catch(err => {
      dispatch({
        type: ASSETS_FAVORITES_MULTI_MOVE_FAILURE,
        payload: err
      })
      sendNotification('error', intl, `${intl.formatMessage({ id: 'assets_could_not_moved' })}`)
    })
  }
}

export const multiAddFavoriteAsset = (workClient, home, assets, intl) => {
  return dispatch => {
    dispatch({ type: ASSET_FAVORITES_MULTI_ADD })
    BunkeyAPI({
      url: `users/me/clients/${workClient}/favorites-multiselection/${home}`,
      method: 'POST',
      data:
      {
        objects: assets.map(e => e._id)
      }
    }).then(resp => {
      dispatch({
        type: ASSET_FAVORITES_MULTI_ADD_SUCCESS,
        payload: {
          data: assets
        }
      })
      sendNotification('success', intl, intl.formatMessage({ id: 'assets_have_been_fav' }))
    }).catch(err => {
      dispatch({
        type: ASSET_FAVORITES_MULTI_ADD_FAILURE,
        payload: {
          error: err
        }
      })
      sendNotification('error', intl, intl.formatMessage({ id: 'assets_could_not_fav' }))
    })
  }
}

export const multiRemoveFavoriteAsset = (workClient, home, assets, intl) => {
  return dispatch => {
    dispatch({ type: ASSET_FAVORITES_MULTI_REMOVE })
    BunkeyAPI({
      url: `users/me/clients/${workClient}/favorites-multiselection/${home}`,
      method: 'DELETE',
      data:
      {
        objects: assets.map(e => e._id)
      }
    }).then(resp => {
      dispatch({
        type: ASSET_FAVORITES_MULTI_REMOVE_SUCCESS,
        payload: {
          data: assets
        }
      })
      sendNotification('success', intl, intl.formatMessage({ id: 'assets_have_been_unfav' }))
    }).catch(err => {
      dispatch({
        type: ASSET_FAVORITES_MULTI_REMOVE_FAILURE,
        payload: {
          error: err
        }
      })
      sendNotification('error', intl, intl.formatMessage({ id: 'assets_could_not_unfav' }))
    })
  }
}